export const specs = {
    run: {
        "name": "run",
        "frames": [{
            "pos": {
                "x": 120,
                "y": 0
            },
            "width": 25,
            "height": 50
        }, {
            "pos": {
                "x": 180,
                "y": 0
            },
            "width": 25,
            "height": 50
        }, {
            "pos": {
                "x": 240,
                "y": 0
            },
            "width": 30,
            "height": 50
        }, {
            "pos": {
                "x": 280,
                "y": 0
            },
            "width": 30,
            "height": 50
        }, {
            "pos": {
                "x": 350,
                "y": 0
            },
            "width": 25,
            "height": 50
        }, {
            "pos": {
                "x": 410,
                "y": 0
            },
            "width": 30,
            "height": 50
        }, {
            "pos": {
                "x": 449,
                "y": 0
            },
            "width": 30,
            "height": 50
        }, {
            "pos": {
                "x": 488,
                "y": 0
            },
            "width": 30,
            "height": 50
        }]
    },
    climb: {
        "name": "climb",
        "frames": [{
            "pos": {
                "x": 217,
                "y": 64
            },
            "width": 20,
            "height": 50
        }, {
            "pos": {
                "x": 250,
                "y": 64
            },
            "width": 20,
            "height": 50
        }]
    },
    attack: {
        "name": "attack",
        "frames": [{
            "pos": {
                "x": 45,
                "y": 123
            },
            "width": 40,
            "height": 60
        }, {
            "pos": {
                "x": 85,
                "y": 123
            },
            "width": 45,
            "height": 60
        }, {
            "pos": {
                "x": 135,
                "y": 123
            },
            "width": 66,
            "height": 60
        }, {
            "pos": {
                "x": 201,
                "y": 123
            },
            "width": 79,
            "height": 60
        }, ]
    }
}